// src/components/Dashboard/ShiftDetailsPanel/ShiftDetailsPanel.styles.js
import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

export const StyledDivider = styled(Box)(({ theme }) => ({
  height: '1px',
  alignSelf: 'center',
  width: '90%',
  marginTop: '-9px',
  marginBottom: '-9px',
  backgroundColor: 'rgba(255, 255, 255, 0.08)',
}));

export const NotesContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.grey[900],
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  width: '100%',
}));

export const RoleHeader = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));

export const RoleTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.grey[100],
}));

export const AddShiftText = styled(Typography)(({ theme }) => ({
  color: theme.colors.blue,
  cursor: 'pointer',
  fontWeight: 500,
}));

export const ShiftCard = styled(
  Box,
  {
    shouldForwardProp: prop => prop !== 'highlighted'
  }
)(({ theme, highlighted }) => {
  return {
    marginTop: theme.spacing(2),
    backgroundColor: highlighted ? theme.palette.grey[800] : theme.palette.grey[900],
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease, transform 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.background.secondaryHover,
      transform: 'translateY(-2px)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
  };
});

export const StyledAvatar = styled(Box)(() => ({}));

export const TextContent = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
}));

export const ShiftInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const ShiftRight = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const ActionButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  width: '100%',
  '& > *': {  // This ensures all direct children take full width
    width: '100% !important',
  },
}));

export const CustomTempoButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#5e2c51',
  color: '#f48fb1',
  textTransform: 'none',
  width: `100%`,
  '&:hover': {
    backgroundColor: '#4b1f41',
  },
}));

export const CustomAddShiftButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  padding: '14px 20px',
  background: theme.palette.background.translucentBlue,
  borderRadius: '12px',
  width: '100%',
  fontSize: '17px',
  color: theme.colors.blue,
  '&:hover': {
    background: '#2C3E50',
    color: theme.colors.blue,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
}));

export const TimeContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const StatusText = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  color: theme.palette.error.main,
}));

export const NoShiftsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  marginTop: theme.spacing(2),
}));

export const NoShiftsText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[100],
}));

export const ShiftListWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
}));

export const RoleSectionWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));